import { union } from '@ngrx/store';

import { PaymentActions } from '@fcom/common-booking';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { BookingState } from '@fcom/common/interfaces/booking';
import { setIn } from '@fcom/core/utils';

import { BookingActions } from '../actions';

// TODO: could the step be moved to the BookingService and this whole state handling removed?
export const initialState: BookingState = {
  step: BOOKING_STEPS.ENTRY,
};

const all = union({ setPaymentStatus: PaymentActions.setPaymentStatus });
type ExtraActions = typeof all;

export function bookingReducer(state = initialState, action: BookingActions.ActionsUnion | ExtraActions): BookingState {
  switch (action.type) {
    case BookingActions.reset.type:
      return initialState;

    case BookingActions.setStep.type:
      return setIn(state, 'step', action.step);

    default:
      return state;
  }
}
